import { useEffect, useState } from 'react'
import ReportedUsageService from './reportedUsageService'

export const useReportedUsageMerchants = (launchId: string) => {
  const [merchants, setMerchants] = useState<string[] | null>(null)
  const [error, setError] = useState('')

  useEffect(() => {
    if (!launchId) {
      setMerchants([])
      return
    }
    let cancelled = false
    setMerchants(null)
    setError('')
    ReportedUsageService.listUploads(launchId)
      .then((response) => {
        if (cancelled) return
        const allowed = response.data?.merchants
        setMerchants(Array.isArray(allowed) ? allowed.map(String) : [])
      })
      .catch(() => {
        if (cancelled) return
        setError('Could not load merchants for this program.')
        setMerchants([])
      })
    return () => {
      cancelled = true
    }
  }, [launchId])

  return { merchants, error, loading: merchants === null }
}
